<template>
  <main class="contenedor contenido-principal sombra">
    <div class="proceso-cafe">
      <div class="imagen">
        <img loading="lazy" decoding="async" src="../../assets/img/proceso_1.jpg" lazyalt="Imagen" width="500" height="300" />
      </div>
      <div class="texto">
        <h3>Granos de café</h3>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ut sunt error placeat. Porro error dolorum nisi tenetur ullam? Quidem architecto mollitia facilis? Obcaecati cum praesentium inventore laboriosam recusandae nobis. Commodi.</p>
      </div>
    </div>
    <div class="proceso-cafe">
      <div class="imagen">
        <img loading="lazy" decoding="async" src="../../assets/img/proceso_2.jpg" lazyalt="Imagen" width="500" height="300" />
      </div>
      <div class="texto">
        <h3>Tostar el café</h3>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ut sunt error placeat. Porro error dolorum nisi tenetur ullam? Quidem architecto mollitia facilis? Obcaecati cum praesentium inventore laboriosam recusandae nobis. Commodi.</p>
      </div>
    </div>
    <div class="proceso-cafe">
      <div class="imagen">
        <img loading="lazy" decoding="async" src="../../assets/img/proceso_3.jpg" lazyalt="Imagen" width="500" height="300" />
      </div>
      <div class="texto">
        <h3>Empacar el café</h3>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ut sunt error placeat. Porro error dolorum nisi tenetur ullam? Quidem architecto mollitia facilis? Obcaecati cum praesentium inventore laboriosam recusandae nobis. Commodi.</p>
      </div>
    </div>
    <div class="proceso-cafe">
      <div class="imagen">
        <img loading="lazy" decoding="async" src="../../assets/img/proceso_4.jpg" lazyalt="Imagen" width="500" height="300" />
      </div>
      <div class="texto">
        <h3>Moler granos de café</h3>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ut sunt error placeat. Porro error dolorum nisi tenetur ullam? Quidem architecto mollitia facilis? Obcaecati cum praesentium inventore laboriosam recusandae nobis. Commodi.</p>
      </div>
    </div>
    <div class="proceso-cafe">
      <div class="imagen">
        <img loading="lazy" decoding="async" src="../../assets/img/proceso_5.jpg" lazyalt="Imagen" width="500" height="300" />
      </div>
      <div class="texto">
        <h3>Disfruta una taza</h3>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ut sunt error placeat. Porro error dolorum nisi tenetur ullam? Quidem architecto mollitia facilis? Obcaecati cum praesentium inventore laboriosam recusandae nobis. Commodi.</p>
      </div>
    </div>
  </main>
</template>

<style scoped>
.proceso-cafe {
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) {
  .proceso-cafe {
    align-items: center;
    flex-direction: row;
    gap: 5rem;
  }
  .proceso-cafe:nth-child(even) {
    flex-direction: row-reverse;
  }
}
.proceso-cafe:last-of-type {
  margin-bottom: 0;
}
.proceso-cafe .imagen,
.proceso-cafe .texto {
  flex: 1;
}
.proceso-cafe .texto {
  margin-top: 1rem;
}
.proceso-cafe .texto h3 {
  text-align: left;
  margin: 0;
  color: #5e311e;
}
.proceso-cafe .texto h3::after {
  content: "";
  width: 20%;
  display: block;
  height: 4px;
  background-color: #c39c63;
}
</style>